import React from "react";
import { Spinner } from "../../components/ui/spinner";

interface SectionStateProps {
  isLoading?: boolean;
  errorText?: string;
  isEmpty?: boolean;
  emptyText?: string;
  minHeightClassName?: string;
  children: React.ReactNode;
}

const SectionState = ({
  isLoading = false,
  errorText = "",
  isEmpty = false,
  emptyText = "No data found.",
  minHeightClassName = "min-h-[200px]",
  children,
}: SectionStateProps) => {
  return (
    <div className={`rounded border p-4 ${minHeightClassName}`}>
      {isLoading ? (
        <div className="flex h-full min-h-[160px] items-center justify-center gap-2 text-sm text-muted-foreground">
          <Spinner className="h-4 w-4" />
          <span>Loading data...</span>
        </div>
      ) : null}

      {!isLoading && errorText ? (
        <div className="flex h-full min-h-[160px] items-center justify-center text-sm text-red-500">
          {errorText}
        </div>
      ) : null}

      {!isLoading && !errorText && isEmpty ? (
        <div className="flex h-full min-h-[160px] items-center justify-center text-sm text-muted-foreground">
          {emptyText}
        </div>
      ) : null}

      {!isLoading && !errorText && !isEmpty ? children : null}
    </div>
  );
};

export default SectionState;
